/* eslint-disable react/display-name */
import { Avatar, Badge, Button, Space, TableColumnType, Tooltip } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { BillingCategoryName } from '../../../models/billingCategory'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { decrypt } from '../../../models/m'
import { getPayFlagName } from '../../../models/payment'
import { getRecipeStatusName } from '../../../models/recipe'
import { getTransactionQueryName } from '../../../models/TransactionQuery'
import { getCardType } from '../../payment/JuhePayPage/columns'
import { ToothComponents } from '../../treatment/editor/modals/toothComponents'
import { useSelector } from 'react-redux'
import { selectEdition } from '../../../app/applicationSlice'

export const Columns = (startIndex?: any): TableColumnType<any>[] => {
  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔
  const columns:TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '结算编号',
      key: 'paymentId',
      align: 'center',
      width: '10rem',
      render: (_, r) => (r?.paymentId ? r?.paymentId : '-'),
      // ellipsis:true,
    },
    {
      title: '门诊号',
      key: 'outpatientNo',
      align: 'center',
      width: '6rem',
      render: (_, r) => (r?.outpatientNo ? r?.outpatientNo : '-'),
      // ellipsis:true,
    },
    {
      title: '患者姓名',
      key: 'patientName',
      align: 'center',
      width: '10rem',
      render: (_, r) => (r?.patientName ? r?.patientName : '-'),
      // ellipsis:true,
    },
    {
      title: '病历号',
      key: 'patientId',
      align: 'center',
      width: '8em',
      dataIndex: 'patientId',
      render: (_, r) => (r?.patientId > -1 ? r?.patientId : '-'),
    },
    {
      title: '身份证号',
      key: 'idCardNumber',
      align: 'center',
      width: '14em',
      dataIndex: 'idCardNumber',
      render: (_, r) => (r?.idCardNumber ? r?.idCardNumber : '-'),
    },
    {
      title: '手机号',
      key: 'patientPhone',
      align: 'center',
      width: '8em',
      dataIndex: 'patientPhone',
      render: (_, r) => {
        return r?.patientPhone ? decrypt(r?.patientPhone) : '-'
      },
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '8em',
      align: 'center',
      render: (_, r) => {
        return r?.insuranceCode === 'ZIFEI' || !r?.insuranceCode
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '人员险种',
      dataIndex: 'xianzhonglx',
      width: '8em',
      align: 'center',
      render: (_, r) => {
        return r?.xianzhonglx == 310 ? '职工' 
        : r?.xianzhonglx == 390 ? '居民' 
         : r?.xianzhonglx == 340 ? '离休' 
         : '-'
      },
    },
    {
      title: '开票项目',
      width: '8em',
      align: 'center',
      dataIndex: 'billingCategory',
      render: (_, t) => {
        return BillingCategoryName(t?.billingCategory)
      },
    },
    {
      title: '项目名称',
      key: 'drugName',
      width: '14rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.drugName ? r?.drugName : '-'
      },
    },
    {
      title: '牙位',
      key: 'toothStruct',
      width: '14rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 8
          }}>
            <ToothComponents data={r.toothStruct} isEdit={false} />
          </div>
        )
      },
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.retailPrice) > -1 ? r?.retailPrice.toFixed(2) : '-'}
          </div>
        )
      }
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.drugCount) > -1 ? r?.drugCount : '-'}
          </div>
        )
      }
    },
    {
      title: '金额',
      dataIndex: 'drugAmount',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {

        return (
          <div
            style={{
              color: r?.state == 5 ? 'red' : '',
            }}
          >
            {Number(r?.drugAmount) > -1 ? r?.drugAmount.toFixed(2) : '-'}
          </div>
        )

      },
    },
    {
      title: '结算状态',
      align: 'center',
      key: 'state',
      width: Dimen.Time,
      render: (_, t) => {
        return (
          <div
            style={{
              color: t?.state == 5 ? 'red' : '',
            }}
          >
            {t?.state ? getTransactionQueryName(Number(t?.state)) : '-'}
          </div>
        )
      }

    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.batchNo ? r?.batchNo : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'deadline',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.deadline
          ? moment(r.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'gysName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, r) => {
        return r?.gysName ? r?.gysName : '-'
      },
    },
    {
      title: '接诊医生',
      key: 'treatmentDoctorName',
      align: 'center',
      width: Dimen.Doctor,
      render: (_, r) => (r?.treatmentDoctorName ? r?.treatmentDoctorName : '-'),
    },
    {
      title: '收费时间',
      key: 'chargeOrRefundTime',
      align: 'center',
      width: '10em',
      render: (_, r) => {
        return r?.chargeOrRefundTime
          ? moment(r?.chargeOrRefundTime)?.format(DateTimeFormat)
          : '-'
      },
    },
    {
      title: '医保结算编号',
      align: 'center',
      key: 'yibaojsbh',
      width: Dimen.IdCardNumber,
      render: (_, t) =>
          t?.yibaojsbh || '-'
    },
    {
      title: '结算就诊编号',
      align: 'center',
      key: 'yibaojzbh',
      width: Dimen.IdCardNumber,
      render: (_, t) =>
          t?.yibaojzbh || '-'
    },
    {
      title: '医保人员编号',
      align: 'center',
      key: 'yibaorybh',
      width: Dimen.IdCardNumber,
      render: (_, t) =>
          t?.yibaorybh
    },
    {
      title: '费用明细流水号',
      align: 'center',
      key: 'fymxid',
      width: Dimen.Time,
      render: (_, t) =>
          t?.fymxid
    },
  ]
  return hisVersion == 1 ? columns : columns.filter(c => c.key !== 'toothStruct')
}
